/**
 * Base snapshot — captures entity state on first local edit.
 *
 * Used by three-way merge to determine which fields the user
 * changed vs. which the server changed.
 */

import { db } from '../database/schema.js'

export async function saveBaseSnapshot(
  entityType: string,
  entityId: string,
  data: Record<string, unknown>
): Promise<void> {
  const existing = await db.syncBaseSnapshots
    .where('[entityType+entityId]')
    .equals([entityType, entityId])
    .first()

  if (existing) return

  await db.syncBaseSnapshots.add({
    id: crypto.randomUUID(),
    entityType,
    entityId,
    data: structuredClone(data),
    createdAt: new Date().toISOString(),
  })
}

export async function getBaseSnapshot(
  entityType: string,
  entityId: string
): Promise<Record<string, unknown> | undefined> {
  const record = await db.syncBaseSnapshots
    .where('[entityType+entityId]')
    .equals([entityType, entityId])
    .first()
  return record?.data
}

export async function clearBaseSnapshot(entityType: string, entityId: string): Promise<void> {
  await db.syncBaseSnapshots.where('[entityType+entityId]').equals([entityType, entityId]).delete()
}

export async function clearAllBaseSnapshots(): Promise<void> {
  await db.syncBaseSnapshots.clear()
}
